import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { OAuth } from '@betwixt/common/utils/auth.js';
import { SetError } from '@betwixt/common';

import Assistant from '@betwixt/common/modules/assistant/my/Assistant.js';
import { getOrSetDefault_Aside_isVisible } from '@betwixt/common/utils/page.js';
import Navs from '../Navs.js';
import Footer from '../Footer.js';
class DynamicImport extends Component {
  _isMounted = false;

  containerREF = React.createRef();

  state = {
    component: null,
    navsAside_isVisible: getOrSetDefault_Aside_isVisible(),
    NavsAsideExtendedComponent: null,
    NavsAsideSecondaryComponent: null,
  };

  componentDidMount = async () => {
    this._isMounted = true;

    this.props.load().then(async (component) => {
      document.body.classList.add(this.props.moduleId);

      const OAuthComp = await OAuth.init(this.props.client, this.props.moduleId);

      if (!OAuthComp.ok) {
        if (OAuthComp.errors) {
          SetError(
            'inPAGE',
            OAuthComp.errors[0].path,
            OAuthComp.errors[0].message,
            this.props.client
          );
        } else {
          OAuth.logout(this.props.client);
        }
      } else {
        // navsAsideExtended
        try {
          const navsAsideExtensions = require(
            `@betwixt/common/modules/${this.props.moduleUrl}/my/NavsAsideExtends.js`
          );
          this.setState({
            ...this.state,
            NavsAsideExtendedComponent: navsAsideExtensions.default || null,
            NavsAsideSecondaryComponent: navsAsideExtensions.NavsAsideSecondary || null,
          });
        } catch (err) {
          // error intentionally silenced
        }

        // i18n | addResourceBundle
        try {
          // console.log("[MODULE] LOADING TRANSLATIONS", this.props.moduleConfig.module.id)
          if (
            this.props.moduleConfig &&
            this.props.moduleConfig.module &&
            this.props.moduleConfig.module.languages
          ) {
            this.props.moduleConfig.module.languages.map((language) => {
              if (
                this.props.i18n.getResourceBundle(language, this.props.moduleConfig.module.id) ===
                undefined
              ) {
                const resource = require(
                  `@betwixt/common/modules/${this.props.moduleUrl}/translation/${language}.json`
                );
                this.props.i18n.addResourceBundle(
                  language,
                  this.props.moduleConfig.module.id,
                  resource,
                  true,
                  true
                );
              }
              return false;
            });
          }
        } catch (err) {
          console.error('[MODULE] TRANSLATION DIRECTORY NOT FOUND', err);
        }

        // load css file
        try {
          require(`@betwixt/common/modules/${this.props.moduleUrl}/client/scss/index.scss`);
        } catch (err) {
          console.error('[MODULE] FILE STYLE NOT FOUND', err);
        }

        // get Module Settings
        try {
          const { GET_SETTINGS } = require(
            `@betwixt/common/modules/${this.props.moduleUrl}/client/graphql/settings`
          );
          await this.props.client.query({ query: GET_SETTINGS });
        } catch (err) {
          // error intentionally silenced
        }

        if (this._isMounted)
          this.setState(() => ({ component: component.default ? component.default : component }));
      }
    });
  };

  componentWillUnmount() {
    this._isMounted = false;
    document.body.classList.remove(this.props.moduleId);
  }

  updatedNavsAside(navsAside_isVisible) {
    this.setState({
      ...this.state,
      navsAside_isVisible,
    });
  }

  render() {
    return (
      <div className="stage">
        <main role="main" className="flex-row" ref={this.containerREF}>
          <Navs
            navType="ASIDE"
            pagename={this.props.pagename}
            parentInfo={this.containerREF.current}
            moduleConfig={this.props.moduleConfig}
            updatedNavsAside={(status) => this.updatedNavsAside(status)}
            NavsAsideExtendedComponent={this.state.NavsAsideExtendedComponent}
            NavsAsideSecondaryComponent={this.state.NavsAsideSecondaryComponent}
            {...this.props}
          />
          <section
            id="module"
            className={`${this.state.navsAside_isVisible ? 'navsAside_isVisible' : ''}`}
          >
            <Assistant {...this.props} />
            {this.props.children(this.state.component)}
          </section>
        </main>
        <Footer i18n={this.props.i18n} without_privacylink={true} gConfig={this.props.gConfig} />
      </div>
    );
  }
}

export default DynamicImport;

DynamicImport.propTypes = {
  moduleId: PropTypes.string.isRequired,
  pagename: PropTypes.string,
  moduleUrl: PropTypes.string.isRequired,
  moduleConfig: PropTypes.shape({
    module: PropTypes.shape({
      id: PropTypes.string,
      languages: PropTypes.arrayOf(PropTypes.string),
    }),
    routes: PropTypes.shape({
      primary: PropTypes.array,
      secondary: PropTypes.array,
      my: PropTypes.shape({
        asideLabelKey: PropTypes.string,
        secondary: PropTypes.array,
        path: PropTypes.string,
      }),
    }),
  }).isRequired,
  t: PropTypes.func,
  i18n: PropTypes.shape({
    getResourceBundle: PropTypes.func,
    addResourceBundle: PropTypes.func,
    getResource: PropTypes.func,
    language: PropTypes.string,
  }).isRequired,
  client: PropTypes.shape({
    query: PropTypes.func,
  }).isRequired,
  gConfig: PropTypes.object,
  User: PropTypes.shape({
    username: PropTypes.string,
    companyname: PropTypes.string,
    modulesActived: PropTypes.array,
  }),
  children: PropTypes.func.isRequired,
  load: PropTypes.func.isRequired,
};
